import { request as getRequest } from './reducers/get';
import { request as queryRequest } from './reducers/query';
import { request as createRequest } from './reducers/create';
import { request as updateRequest } from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default {
    STAFF_GET_REQUEST: getRequest,
    STAFF_QUERY_REQUEST: queryRequest,
    STAFF_CREATE_REQUEST: createRequest,
    STAFF_UPDATE_REQUEST: updateRequest,
};
